// extracted by mini-css-extract-plugin
export default {"icon":"Page404_icon__OH0x6"};